import React, { useState, memo } from 'react'
import isEqual from 'lodash/isEqual'

import Active from '../../commons/Active'
import Inactive from '../../commons/Inactive'
import TableCell from '../../commons/TableCell'
import ResultsTable from '../../ResultsTable'
import DropZoneVideo from 'components/ResultsTable/Components/DropZoneVideo'
import { useHasOperation } from 'hooks/useHasOperation'
import { OPERACIONES_FUNCIONALIDAD } from 'utils/constants'

const FunctionalityTable = ({
   isSearch,
   order,
   functionalities,
   searchFunctionalitites,
   actionEdit,
   cleanCallback
}) => {
   const [selected, setSelected] = useState({})

   const EDITAR_FUNCIONALIDAD = useHasOperation(OPERACIONES_FUNCIONALIDAD.EDITAR)
   const VER_CODIGO_FUNCIONALIDAD = useHasOperation(OPERACIONES_FUNCIONALIDAD.VER_CODIGO)
   const CARGAR_VIDEO_FUNCIONALIDAD = useHasOperation(OPERACIONES_FUNCIONALIDAD.CARGAR_VIDEO)

   const columns = [
      {
         title: 'NOMBRE FUNCIONALIDAD',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'DESCRIPCIÓN FUNCIONALIDAD',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.description} />
      },
      {
         title: 'ESTADO FUNCIONALIDAD',
         field: 'status',
         align: 'center',
         sorting: false,
         render: rowData => (rowData?.status === 'A' ? <Active /> : <Inactive />)
      },
      {
         title: 'URL FUNCIONALIDAD',
         field: 'link',
         sorting: false,
         align: 'center'
      },
      {
         title: 'NOMBRE MÓDULO',
         field: 'module.name',
         sorting: false,
         align: 'center',
         render: rowData => <TableCell text={rowData?.module?.name} />
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         sorting: false,
         align: 'center'
      }
   ]

   const customActions = [
      CARGAR_VIDEO_FUNCIONALIDAD && {
         icon: 'video_call',
         tooltip: 'Subir video',
         onClick: (_, rowData) => setSelected(rowData)
      },
      EDITAR_FUNCIONALIDAD && {
         icon: 'edit',
         tooltip: 'Editar fila',
         onClick: (_, rowData) => actionEdit(rowData)
      }
   ]

   const closeDropZone = () => setSelected({})

   return (
      <ResultsTable
         columns={columns}
         tableData={functionalities}
         isSearch={isSearch}
         searchCallback={searchFunctionalitites}
         cleanCallback={cleanCallback}
         customActions={customActions}
         order={order}
         enableKey={VER_CODIGO_FUNCIONALIDAD}
         RowComponent={props => <RowComponent {...props} selected={selected} closeDropZone={closeDropZone} />}
      />
   )
}

const RowComponent = ({ data, selected, closeDropZone }) => (
   <>{isEqual(data?.id, selected?.id) && <DropZoneVideo selected={selected} closeDropZone={closeDropZone} />}</>
)

export default memo(FunctionalityTable)
